// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_scribe_encounter.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { EncounterKind, NoteBlock, NoteContextKey, NoteLine, NoteNumberValue, NoteTableRowValue, NoteTeethGroup, NoteToothMark } from "./dto_scribe_catalog_pb.js";

/**
 * @generated from enum com.diagnocat.model.EncounterStatus
 */
export const EncounterStatus = proto3.makeEnum(
  "com.diagnocat.model.EncounterStatus",
  [
    {no: 0, name: "EncounterStatusInvalidValue"},
    {no: 1, name: "EncounterStatusAwaitingUpload"},
    {no: 2, name: "EncounterStatusRecording"},
    {no: 3, name: "EncounterStatusProcessingQueued"},
    {no: 4, name: "EncounterStatusProcessing"},
    {no: 5, name: "EncounterStatusCompleted"},
    {no: 6, name: "EncounterStatusFailed"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.FragmentStatus
 */
export const FragmentStatus = proto3.makeEnum(
  "com.diagnocat.model.FragmentStatus",
  [
    {no: 0, name: "FragmentStatusInvalidValue"},
    {no: 1, name: "FragmentStatusAwaitingUpload"},
    {no: 2, name: "FragmentStatusUploaded"},
    {no: 3, name: "FragmentStatusRecording"},
    {no: 4, name: "FragmentStatusStopped"},
    {no: 5, name: "FragmentStatusCompleted"},
    {no: 6, name: "FragmentStatusFailed"},
  ],
);

/**
 * Why a recording fragment left the recording state. InvalidValue means the
 * fragment predates the field (or never recorded) — treat as unknown.
 *
 * @generated from enum com.diagnocat.model.FragmentStopReason
 */
export const FragmentStopReason = proto3.makeEnum(
  "com.diagnocat.model.FragmentStopReason",
  [
    {no: 0, name: "FragmentStopReasonInvalidValue"},
    {no: 1, name: "FragmentStopReasonUser"},
    {no: 2, name: "FragmentStopReasonClientInterrupted"},
    {no: 3, name: "FragmentStopReasonStaleWatchdog"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.EncounterDocumentStatus
 */
export const EncounterDocumentStatus = proto3.makeEnum(
  "com.diagnocat.model.EncounterDocumentStatus",
  [
    {no: 0, name: "EncounterDocumentStatusInvalidValue"},
    {no: 1, name: "EncounterDocumentStatusPending"},
    {no: 2, name: "EncounterDocumentStatusGenerating"},
    {no: 3, name: "EncounterDocumentStatusSkipped"},
    {no: 4, name: "EncounterDocumentStatusCompleted"},
    {no: 5, name: "EncounterDocumentStatusFailed"},
    {no: 6, name: "EncounterDocumentStatusEdited"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.EncounterDocumentType
 */
export const EncounterDocumentType = proto3.makeEnum(
  "com.diagnocat.model.EncounterDocumentType",
  [
    {no: 0, name: "EncounterDocumentTypeInvalidValue"},
    {no: 1, name: "EncounterDocumentTypeSummary"},
    {no: 2, name: "EncounterDocumentTypeLetter"},
    {no: 3, name: "EncounterDocumentTypeFollowUpLetter"},
    {no: 4, name: "EncounterDocumentTypeProtocol"},
    {no: 5, name: "EncounterDocumentTypeEvaluation"},
    {no: 6, name: "EncounterDocumentTypeTemplate"},
    {no: 7, name: "EncounterDocumentTypeLiteratureReview"},
  ],
);

/**
 * DocumentationMode is the encounter-wide formatting hint the document
 * generator obeys. Unset is read as Protocol.
 *
 * @generated from enum com.diagnocat.model.DocumentationMode
 */
export const DocumentationMode = proto3.makeEnum(
  "com.diagnocat.model.DocumentationMode",
  [
    {no: 0, name: "DocumentationModeInvalidValue"},
    {no: 1, name: "DocumentationModeProtocol"},
  ],
);

/**
 * Unset means visit for records created before recording modes existed.
 *
 * @generated from enum com.diagnocat.model.RecordingMode
 */
export const RecordingMode = proto3.makeEnum(
  "com.diagnocat.model.RecordingMode",
  [
    {no: 0, name: "RecordingModeInvalidValue"},
    {no: 1, name: "RecordingModeVisit"},
    {no: 2, name: "RecordingModeDictation"},
  ],
);

/**
 * ModelType is the LLM tier the document generator used to run against.
 * Deprecated: the model is now resolved per call purpose. Scribe no longer
 * stores or reports a tier; the enum and the fields of this type stay only for
 * wire compatibility and are always left unset.
 *
 * @generated from enum com.diagnocat.model.ModelType
 */
export const ModelType = proto3.makeEnum(
  "com.diagnocat.model.ModelType",
  [
    {no: 0, name: "ModelTypeInvalidValue"},
    {no: 1, name: "ModelTypeFast"},
    {no: 2, name: "ModelTypeSmart"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.DocumentEditIssueType
 */
export const DocumentEditIssueType = proto3.makeEnum(
  "com.diagnocat.model.DocumentEditIssueType",
  [
    {no: 0, name: "DocumentEditIssueTypeInvalidValue"},
    {no: 1, name: "DocumentEditIssueTypeHallucination"},
    {no: 2, name: "DocumentEditIssueTypeOmission"},
    {no: 3, name: "DocumentEditIssueTypeWrongSection"},
    {no: 4, name: "DocumentEditIssueTypeOther"},
  ],
);

/**
 * DocumentEditFeedback records why a user rewrote a section.
 * Who set a structured answer of a protocol document. A manual answer is never
 * changed by AI; an explicit manual clear is a manual answer with no values.
 *
 * @generated from enum com.diagnocat.model.DocumentAnswerSource
 */
export const DocumentAnswerSource = proto3.makeEnum(
  "com.diagnocat.model.DocumentAnswerSource",
  [
    {no: 0, name: "DocumentAnswerSourceInvalidValue"},
    {no: 1, name: "DocumentAnswerSourceAI"},
    {no: 2, name: "DocumentAnswerSourceManual"},
  ],
);

/**
 * Where the quote of an AI value comes from.
 *
 * @generated from enum com.diagnocat.model.NoteEvidenceSource
 */
export const NoteEvidenceSource = proto3.makeEnum(
  "com.diagnocat.model.NoteEvidenceSource",
  [
    {no: 0, name: "NoteEvidenceSourceInvalidValue"},
    {no: 1, name: "NoteEvidenceSourceTranscript"},
    {no: 2, name: "NoteEvidenceSourceInstruction"},
  ],
);

/**
 * What an AI value of a block note rests on. The clinician sees it on every
 * AI value; an assumption blocks "Save to record" and copy until the
 * clinician confirms it (a manual set of the same value) or clears it.
 *
 * @generated from enum com.diagnocat.model.NoteAIBasis
 */
export const NoteAIBasis = proto3.makeEnum(
  "com.diagnocat.model.NoteAIBasis",
  [
    {no: 0, name: "NoteAIBasisNone"},
    {no: 1, name: "NoteAIBasisStated"},
    {no: 2, name: "NoteAIBasisMatched"},
    {no: 3, name: "NoteAIBasisNewOption"},
    {no: 4, name: "NoteAIBasisAssumed"},
    {no: 5, name: "NoteAIBasisSuggested"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteToothNotation
 */
export const NoteToothNotation = proto3.makeEnum(
  "com.diagnocat.model.NoteToothNotation",
  [
    {no: 0, name: "NoteToothNotationInvalidValue"},
    {no: 1, name: "NoteToothNotationISO"},
    {no: 2, name: "NoteToothNotationUniversal"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteLineStatus
 */
export const NoteLineStatus = proto3.makeEnum(
  "com.diagnocat.model.NoteLineStatus",
  [
    {no: 0, name: "NoteLineStatusInvalidValue"},
    {no: 1, name: "NoteLineStatusIncluded"},
    {no: 2, name: "NoteLineStatusUnresolved"},
    {no: 3, name: "NoteLineStatusHidden"},
    {no: 4, name: "NoteLineStatusDeleted"},
    {no: 5, name: "NoteLineStatusSkipped"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteAIStepKind
 */
export const NoteAIStepKind = proto3.makeEnum(
  "com.diagnocat.model.NoteAIStepKind",
  [
    {no: 0, name: "NoteAIStepKindInvalidValue"},
    {no: 1, name: "NoteAIStepKindClick"},
    {no: 2, name: "NoteAIStepKindModify"},
    {no: 3, name: "NoteAIStepKindComplete"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteAIStepPhase
 */
export const NoteAIStepPhase = proto3.makeEnum(
  "com.diagnocat.model.NoteAIStepPhase",
  [
    {no: 0, name: "NoteAIStepPhaseInvalidValue"},
    {no: 1, name: "NoteAIStepPhaseLive"},
    {no: 2, name: "NoteAIStepPhaseFinal"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteAIDropReason
 */
export const NoteAIDropReason = proto3.makeEnum(
  "com.diagnocat.model.NoteAIDropReason",
  [
    {no: 0, name: "NoteAIDropReasonInvalidValue"},
    {no: 1, name: "NoteAIDropReasonUnknownBlock"},
    {no: 2, name: "NoteAIDropReasonUnknownLine"},
    {no: 3, name: "NoteAIDropReasonUnknownSection"},
    {no: 4, name: "NoteAIDropReasonNotClickable"},
    {no: 5, name: "NoteAIDropReasonNotEditable"},
    {no: 6, name: "NoteAIDropReasonLineHidden"},
    {no: 7, name: "NoteAIDropReasonLineClosed"},
    {no: 8, name: "NoteAIDropReasonSticky"},
    {no: 9, name: "NoteAIDropReasonWithoutEvidence"},
    {no: 10, name: "NoteAIDropReasonQuoteNotInEvidence"},
    {no: 11, name: "NoteAIDropReasonValueNotAllowed"},
    {no: 12, name: "NoteAIDropReasonTooManyValues"},
    {no: 13, name: "NoteAIDropReasonEmptyValue"},
    {no: 14, name: "NoteAIDropReasonOtherNotAllowed"},
    {no: 15, name: "NoteAIDropReasonConflictingOperations"},
    {no: 16, name: "NoteAIDropReasonTooLong"},
    {no: 17, name: "NoteAIDropReasonDuplicate"},
    {no: 18, name: "NoteAIDropReasonLimit"},
    {no: 19, name: "NoteAIDropReasonNotAIValue"},
    {no: 20, name: "NoteAIDropReasonRewriteNotAllowed"},
    {no: 21, name: "NoteAIDropReasonUnknownRef"},
    {no: 22, name: "NoteAIDropReasonQuoteNotFound"},
    {no: 23, name: "NoteAIDropReasonEditNoUniqueMatch"},
    {no: 24, name: "NoteAIDropReasonEditInGuidance"},
    {no: 25, name: "NoteAIDropReasonLineHasValue"},
    {no: 26, name: "NoteAIDropReasonPlaceholder"},
    {no: 27, name: "NoteAIDropReasonOtherBlockValue"},
    {no: 28, name: "NoteAIDropReasonNotOffered"},
    {no: 29, name: "NoteAIDropReasonWithoutRationale"},
    {no: 30, name: "NoteAIDropReasonCodeNotStated"},
    {no: 31, name: "NoteAIDropReasonNoneNotStated"},
    {no: 32, name: "NoteAIDropReasonConfirmed"},
    {no: 33, name: "NoteAIDropReasonNotNewer"},
    {no: 34, name: "NoteAIDropReasonNoPremise"},
    {no: 35, name: "NoteAIDropReasonNoneWithValues"},
  ],
);

/**
 * The transcript an AI step read.
 *
 * @generated from enum com.diagnocat.model.NoteAITranscript
 */
export const NoteAITranscript = proto3.makeEnum(
  "com.diagnocat.model.NoteAITranscript",
  [
    {no: 0, name: "NoteAITranscriptInvalidValue"},
    {no: 1, name: "NoteAITranscriptLive"},
    {no: 2, name: "NoteAITranscriptFile"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteCompletionStatus
 */
export const NoteCompletionStatus = proto3.makeEnum(
  "com.diagnocat.model.NoteCompletionStatus",
  [
    {no: 0, name: "NoteCompletionStatusInvalidValue"},
    {no: 1, name: "NoteCompletionStatusQueued"},
    {no: 2, name: "NoteCompletionStatusRunning"},
    {no: 3, name: "NoteCompletionStatusFinished"},
    {no: 4, name: "NoteCompletionStatusFailed"},
  ],
);

/**
 * @generated from message com.diagnocat.model.Encounter
 */
export const Encounter = proto3.makeMessageType(
  "com.diagnocat.model.Encounter",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "StaffMemberID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "DocumentationMode", kind: "enum", T: proto3.getEnumType(DocumentationMode) },
    { no: 9, name: "ModelType", kind: "enum", T: proto3.getEnumType(ModelType) },
    { no: 10, name: "Lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Status", kind: "enum", T: proto3.getEnumType(EncounterStatus) },
    { no: 12, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "SchemaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "SchemaCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "SchemaName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "Kind", kind: "enum", T: proto3.getEnumType(EncounterKind) },
    { no: 31, name: "TranscriptorV2", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 32, name: "RecordingMode", kind: "enum", T: proto3.getEnumType(RecordingMode) },
    { no: 33, name: "DictationDeadlineAt", kind: "message", T: Timestamp, opt: true },
    { no: 16, name: "Fragments", kind: "message", T: EncounterFragment, repeated: true },
    { no: 17, name: "Documents", kind: "message", T: EncounterDocument, repeated: true },
    { no: 18, name: "Analytics", kind: "message", T: Struct },
    { no: 19, name: "EvaluationOverallScore", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 27, name: "Abstract", kind: "message", T: EncounterAbstract, opt: true },
    { no: 20, name: "PatientInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 21, name: "ExtractedPatientInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 22, name: "ExtractedStaffInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 28, name: "StaffInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 29, name: "Archived", kind: "message", T: Archival, opt: true },
    { no: 23, name: "Deletion", kind: "message", T: Deletion, opt: true },
    { no: 24, name: "StartedAt", kind: "message", T: Timestamp, opt: true },
    { no: 25, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 26, name: "UpdatedAt", kind: "message", T: Timestamp },
    { no: 10020, name: "YourPermissions", kind: "message", T: EncounterPermissions },
  ],
);

/**
 * EncounterPreview is the list projection of Encounter: no fragments,
 * documents or analytics, plus a summed audio duration.
 *
 * @generated from message com.diagnocat.model.EncounterPreview
 */
export const EncounterPreview = proto3.makeMessageType(
  "com.diagnocat.model.EncounterPreview",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "StaffMemberID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "DocumentationMode", kind: "enum", T: proto3.getEnumType(DocumentationMode) },
    { no: 9, name: "ModelType", kind: "enum", T: proto3.getEnumType(ModelType) },
    { no: 10, name: "Lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Status", kind: "enum", T: proto3.getEnumType(EncounterStatus) },
    { no: 12, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "SchemaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "SchemaCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "SchemaName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "Kind", kind: "enum", T: proto3.getEnumType(EncounterKind) },
    { no: 29, name: "TranscriptorV2", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "RecordingMode", kind: "enum", T: proto3.getEnumType(RecordingMode) },
    { no: 31, name: "DictationDeadlineAt", kind: "message", T: Timestamp, opt: true },
    { no: 16, name: "EvaluationOverallScore", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 25, name: "Abstract", kind: "message", T: EncounterAbstract, opt: true },
    { no: 17, name: "PatientInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 18, name: "ExtractedPatientInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 19, name: "ExtractedStaffInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 26, name: "StaffInfo", kind: "message", T: PersonalInfo, opt: true },
    { no: 27, name: "Archived", kind: "message", T: Archival, opt: true },
    { no: 20, name: "Deletion", kind: "message", T: Deletion, opt: true },
    { no: 21, name: "TotalAudioDurationNS", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 22, name: "StartedAt", kind: "message", T: Timestamp, opt: true },
    { no: 23, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 24, name: "UpdatedAt", kind: "message", T: Timestamp },
    { no: 10020, name: "YourPermissions", kind: "message", T: EncounterPermissions },
  ],
);

/**
 * EncounterPermissions is what the caller may do with the encounter carrying it.
 *
 * @generated from message com.diagnocat.model.EncounterPermissions
 */
export const EncounterPermissions = proto3.makeMessageType(
  "com.diagnocat.model.EncounterPermissions",
  () => [
    { no: 1, name: "CanViewEvaluation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "CanArchive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "CanRestore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "CanDelete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * EncounterAbstract is the executive summary generated from the encounter's
 * completed summary documents. Status tracks the generation call.
 *
 * @generated from message com.diagnocat.model.EncounterAbstract
 */
export const EncounterAbstract = proto3.makeMessageType(
  "com.diagnocat.model.EncounterAbstract",
  () => [
    { no: 1, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Status", kind: "enum", T: proto3.getEnumType(EncounterDocumentStatus) },
    { no: 3, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 5, name: "UpdatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message com.diagnocat.model.EncounterFragment
 */
export const EncounterFragment = proto3.makeMessageType(
  "com.diagnocat.model.EncounterFragment",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Status", kind: "enum", T: proto3.getEnumType(FragmentStatus) },
    { no: 3, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Audio", kind: "message", T: StoredAudio, opt: true },
    { no: 5, name: "Transcript", kind: "message", T: Transcript, opt: true },
    { no: 6, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 7, name: "UpdatedAt", kind: "message", T: Timestamp },
    { no: 8, name: "StopReason", kind: "enum", T: proto3.getEnumType(FragmentStopReason) },
  ],
);

/**
 * @generated from message com.diagnocat.model.StoredAudio
 */
export const StoredAudio = proto3.makeMessageType(
  "com.diagnocat.model.StoredAudio",
  () => [
    { no: 1, name: "URL", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Duration", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "ContentType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "FileName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.Transcript
 */
export const Transcript = proto3.makeMessageType(
  "com.diagnocat.model.Transcript",
  () => [
    { no: 1, name: "Lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Chunks", kind: "message", T: TranscriptChunk, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.TranscriptChunk
 */
export const TranscriptChunk = proto3.makeMessageType(
  "com.diagnocat.model.TranscriptChunk",
  () => [
    { no: 1, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Start", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "End", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "Speaker", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.EncounterDocument
 */
export const EncounterDocument = proto3.makeMessageType(
  "com.diagnocat.model.EncounterDocument",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "TemplateSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "Type", kind: "enum", T: proto3.getEnumType(EncounterDocumentType) },
    { no: 9, name: "Status", kind: "enum", T: proto3.getEnumType(EncounterDocumentStatus) },
    { no: 10, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "UserEditable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "Sections", kind: "message", T: EncounterDocumentSection, repeated: true },
    { no: 13, name: "References", kind: "message", T: LiteratureReference, repeated: true },
    { no: 14, name: "OverallScore", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 24, name: "RequiresApproval", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "Approved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "ApprovedAt", kind: "message", T: Timestamp, opt: true },
    { no: 17, name: "ApprovedByUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "GenerationModel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "GenerationModelType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "GenerationModelName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "GenerationModelProvider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 23, name: "UpdatedAt", kind: "message", T: Timestamp },
    { no: 25, name: "SectionOverrides", kind: "message", T: EncounterDocumentSectionOverride, repeated: true },
  ],
);

/**
 * EncounterDocumentSectionOverride is one section of a summary or evaluation
 * as this encounter's clinician set it before the recording: the template
 * section's Code, its Title and its AI Instructions.
 *
 * @generated from message com.diagnocat.model.EncounterDocumentSectionOverride
 */
export const EncounterDocumentSectionOverride = proto3.makeMessageType(
  "com.diagnocat.model.EncounterDocumentSectionOverride",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.EncounterDocumentSection
 */
export const EncounterDocumentSection = proto3.makeMessageType(
  "com.diagnocat.model.EncounterDocumentSection",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "UserContent", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 7, name: "EditFeedback", kind: "message", T: DocumentEditFeedback, repeated: true },
  ],
);

/**
 * Addresses one field of the pinned template version: a section without
 * options (OptionIndex = -1, Slot empty), a statement option (Slot empty), or
 * one slot of an option.
 *
 * @generated from message com.diagnocat.model.DocumentAnswerKey
 */
export const DocumentAnswerKey = proto3.makeMessageType(
  "com.diagnocat.model.DocumentAnswerKey",
  () => [
    { no: 1, name: "SectionCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OptionIndex", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "Slot", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "BlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.DocumentAnswer
 */
export const DocumentAnswer = proto3.makeMessageType(
  "com.diagnocat.model.DocumentAnswer",
  () => [
    { no: 1, name: "Key", kind: "message", T: DocumentAnswerKey },
    { no: 2, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Source", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource) },
    { no: 5, name: "Cleared", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "OptionText", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "EvidenceChunkIndexes", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 8, name: "Teeth", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "TeethGroups", kind: "enum", T: proto3.getEnumType(NoteTeethGroup), repeated: true },
    { no: 10, name: "EvidenceQuote", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "UpdatedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "AIStepID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "CanRevert", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "Correction", kind: "message", T: NoteAnswerCorrection, opt: true },
    { no: 15, name: "AIBasis", kind: "enum", T: proto3.getEnumType(NoteAIBasis) },
    { no: 16, name: "AISaid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "AIRationale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "Date", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "None", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 20, name: "Marks", kind: "message", T: NoteAnswerMark, repeated: true },
    { no: 21, name: "EvidenceSource", kind: "enum", T: proto3.getEnumType(NoteEvidenceSource), opt: true },
    { no: 22, name: "Numbers", kind: "message", T: NoteNumberValue, repeated: true },
    { no: 23, name: "TableRows", kind: "message", T: NoteAnswerTableRow, repeated: true },
    { no: 24, name: "AIConfirmed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * One row of a table answer (NoteTableRowValue with provenance).
 *
 * @generated from message com.diagnocat.model.NoteAnswerTableRow
 */
export const NoteAnswerTableRow = proto3.makeMessageType(
  "com.diagnocat.model.NoteAnswerTableRow",
  () => [
    { no: 1, name: "Row", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Cells", kind: "message", T: NoteAnswerTableCell, repeated: true },
  ],
);

/**
 * One cell of a table answer with its provenance: who set it (unset for a
 * cell nobody set) and, for an AI cell, what it rests on and the excerpt it
 * was read from.
 *
 * @generated from message com.diagnocat.model.NoteAnswerTableCell
 */
export const NoteAnswerTableCell = proto3.makeMessageType(
  "com.diagnocat.model.NoteAnswerTableCell",
  () => [
    { no: 1, name: "Column", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Source", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource) },
    { no: 4, name: "AIBasis", kind: "enum", T: proto3.getEnumType(NoteAIBasis) },
    { no: 5, name: "EvidenceQuote", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "AIConfirmed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * One mark of a teeth answer with its provenance.
 *
 * @generated from message com.diagnocat.model.NoteAnswerMark
 */
export const NoteAnswerMark = proto3.makeMessageType(
  "com.diagnocat.model.NoteAnswerMark",
  () => [
    { no: 1, name: "Mark", kind: "message", T: NoteToothMark },
    { no: 2, name: "Source", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource) },
    { no: 3, name: "AIBasis", kind: "enum", T: proto3.getEnumType(NoteAIBasis) },
    { no: 4, name: "EvidenceQuote", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "AIConfirmed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * NoteAnswerCorrection is a correction hint on a block that holds an AI value.
 *
 * @generated from message com.diagnocat.model.NoteAnswerCorrection
 */
export const NoteAnswerCorrection = proto3.makeMessageType(
  "com.diagnocat.model.NoteAnswerCorrection",
  () => [
    { no: 1, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Teeth", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "TeethGroups", kind: "enum", T: proto3.getEnumType(NoteTeethGroup), repeated: true },
    { no: 5, name: "EvidenceChunkIndexes", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 6, name: "AIStepID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "UpdatedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * Free narrative for a flexible section, kept apart from option answers.
 *
 * @generated from message com.diagnocat.model.DocumentSectionNote
 */
export const DocumentSectionNote = proto3.makeMessageType(
  "com.diagnocat.model.DocumentSectionNote",
  () => [
    { no: 1, name: "SectionCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Source", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource) },
  ],
);

/**
 * Structured answers of one protocol document in an encounter.
 *
 * @generated from message com.diagnocat.model.DocumentAnswers
 */
export const DocumentAnswers = proto3.makeMessageType(
  "com.diagnocat.model.DocumentAnswers",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Revision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "TranscriptRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "Answers", kind: "message", T: DocumentAnswer, repeated: true },
    { no: 7, name: "Notes", kind: "message", T: DocumentSectionNote, repeated: true },
    { no: 8, name: "LineStates", kind: "message", T: NoteLineState, repeated: true },
    { no: 9, name: "LineNotes", kind: "message", T: NoteLineNote, repeated: true },
    { no: 10, name: "Context", kind: "message", T: NoteContextSnapshot, opt: true },
    { no: 11, name: "AddedLines", kind: "message", T: NoteAddedLine, repeated: true },
    { no: 12, name: "AddedBlocks", kind: "message", T: NoteAddedBlock, repeated: true },
    { no: 13, name: "View", kind: "message", T: NoteView, opt: true },
    { no: 14, name: "LineOrders", kind: "message", T: NoteSectionLineOrder, repeated: true },
    { no: 15, name: "Completion", kind: "message", T: NoteCompletion, opt: true },
    { no: 16, name: "OwnOptions", kind: "message", T: NoteBlockOwnOptions, repeated: true },
    { no: 17, name: "AppliedTranscriptRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * The own options of one choice, multi_choice or list_ref block: offered on
 * this note after the values the block lists (its own or its list's), in the
 * order added, never equal to one of those values or to each other (ignoring
 * case and spacing).
 *
 * @generated from message com.diagnocat.model.NoteBlockOwnOptions
 */
export const NoteBlockOwnOptions = proto3.makeMessageType(
  "com.diagnocat.model.NoteBlockOwnOptions",
  () => [
    { no: 1, name: "BlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "UpdatedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * Per-line state of a block note. A line absent from the list is open and was
 * never revealed.
 *
 * @generated from message com.diagnocat.model.NoteLineState
 */
export const NoteLineState = proto3.makeMessageType(
  "com.diagnocat.model.NoteLineState",
  () => [
    { no: 1, name: "LineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "Skipped", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "RevealedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "UpdatedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "DeletedBy", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource), opt: true },
    { no: 7, name: "AIStepID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "EvidenceChunkIndexes", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 9, name: "EvidenceQuote", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * A clinician's note appended to one line. Manual only.
 *
 * @generated from message com.diagnocat.model.NoteLineNote
 */
export const NoteLineNote = proto3.makeMessageType(
  "com.diagnocat.model.NoteLineNote",
  () => [
    { no: 1, name: "LineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "UpdatedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * The clinician's order of the lines of one section: template and added line
 * ids. Lines it does not list (added later, or left out) follow the line they
 * follow in template order.
 *
 * @generated from message com.diagnocat.model.NoteSectionLineOrder
 */
export const NoteSectionLineOrder = proto3.makeMessageType(
  "com.diagnocat.model.NoteSectionLineOrder",
  () => [
    { no: 1, name: "SectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LineIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "UpdatedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.NoteContextValue
 */
export const NoteContextValue = proto3.makeMessageType(
  "com.diagnocat.model.NoteContextValue",
  () => [
    { no: 1, name: "Key", kind: "enum", T: proto3.getEnumType(NoteContextKey) },
    { no: 2, name: "Value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Values scribe resolved from core for this note. The notation is fixed at the
 * first write; the other values are refreshed when the encounter's staff
 * member or patient changes.
 *
 * @generated from message com.diagnocat.model.NoteContextSnapshot
 */
export const NoteContextSnapshot = proto3.makeMessageType(
  "com.diagnocat.model.NoteContextSnapshot",
  () => [
    { no: 1, name: "Notation", kind: "enum", T: proto3.getEnumType(NoteToothNotation) },
    { no: 2, name: "Values", kind: "message", T: NoteContextValue, repeated: true },
    { no: 3, name: "StaffMemberID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "TimeZone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ResolvedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * A line added on this note: by the clinician ("+ Add line") or by the
 * after-Stop AI step. One text block.
 *
 * @generated from message com.diagnocat.model.NoteAddedLine
 */
export const NoteAddedLine = proto3.makeMessageType(
  "com.diagnocat.model.NoteAddedLine",
  () => [
    { no: 1, name: "SectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AfterLineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Line", kind: "message", T: NoteLine },
    { no: 4, name: "Source", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource) },
    { no: 5, name: "EvidenceChunkIndexes", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 6, name: "EvidenceQuote", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Removed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "AIStepID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "UpdatedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * A text block the after-Stop AI step added to a template line.
 *
 * @generated from message com.diagnocat.model.NoteAddedBlock
 */
export const NoteAddedBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteAddedBlock",
  () => [
    { no: 1, name: "LineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AfterBlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Block", kind: "message", T: NoteBlock },
    { no: 4, name: "Source", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource) },
    { no: 5, name: "EvidenceChunkIndexes", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 6, name: "EvidenceQuote", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Removed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "AIStepID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "UpdatedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * NoteView is the note as scribe renders it. It is derived; the client lays it
 * out and never recomputes it.
 *
 * @generated from message com.diagnocat.model.NoteView
 */
export const NoteView = proto3.makeMessageType(
  "com.diagnocat.model.NoteView",
  () => [
    { no: 1, name: "Sections", kind: "message", T: NoteSectionView, repeated: true },
    { no: 2, name: "UnresolvedLineCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "ReadyToFinish", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "UnconfirmedAssumptionCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "PartnerDefaults", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.NoteSectionView
 */
export const NoteSectionView = proto3.makeMessageType(
  "com.diagnocat.model.NoteSectionView",
  () => [
    { no: 1, name: "SectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SectionCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Lines", kind: "message", T: NoteLineView, repeated: true },
    { no: 5, name: "UnresolvedLineCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "MissingRequired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "CustomLineOrder", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.NoteLineView
 */
export const NoteLineView = proto3.makeMessageType(
  "com.diagnocat.model.NoteLineView",
  () => [
    { no: 1, name: "LineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Status", kind: "enum", T: proto3.getEnumType(NoteLineStatus) },
    { no: 3, name: "AddedBy", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource), opt: true },
    { no: 4, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Blocks", kind: "message", T: NoteBlockView, repeated: true },
    { no: 6, name: "RevealedAtRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "Note", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "DeletedBy", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource), opt: true },
    { no: 9, name: "PartnerTeethMissing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * One run of a block's printed text.
 *
 * @generated from message com.diagnocat.model.NoteTextSpan
 */
export const NoteTextSpan = proto3.makeMessageType(
  "com.diagnocat.model.NoteTextSpan",
  () => [
    { no: 1, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AI", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.NoteBlockView
 */
export const NoteBlockView = proto3.makeMessageType(
  "com.diagnocat.model.NoteBlockView",
  () => [
    { no: 1, name: "BlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Resolved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "Source", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource), opt: true },
    { no: 5, name: "AddedBy", kind: "enum", T: proto3.getEnumType(DocumentAnswerSource), opt: true },
    { no: 6, name: "CorrectionText", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "TextSpans", kind: "message", T: NoteTextSpan, repeated: true },
    { no: 8, name: "AIBasis", kind: "enum", T: proto3.getEnumType(NoteAIBasis), opt: true },
    { no: 9, name: "AISaid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "AIRationale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "PartnerDefaultText", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "EvidenceSource", kind: "enum", T: proto3.getEnumType(NoteEvidenceSource), opt: true },
    { no: 13, name: "AIConfirmed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * One AI step on one document: a click round or the modify step. Append-only.
 * Values are clinical data of the same class as the answers: never logged.
 *
 * @generated from message com.diagnocat.model.NoteAIStep
 */
export const NoteAIStep = proto3.makeMessageType(
  "com.diagnocat.model.NoteAIStep",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Kind", kind: "enum", T: proto3.getEnumType(NoteAIStepKind) },
    { no: 6, name: "Phase", kind: "enum", T: proto3.getEnumType(NoteAIStepPhase) },
    { no: 7, name: "Round", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "TranscriptRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "TranscriptChunkFrom", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "TranscriptChunkTo", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "AnswersRevisionBefore", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "AnswersRevisionAfter", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "Applied", kind: "message", T: NoteAIStepChange, repeated: true },
    { no: 14, name: "AddedLineIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "AddedBlockIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "RevealedLineIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "Dropped", kind: "message", T: NoteAIStepDrop, repeated: true },
    { no: 18, name: "Model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "Provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "LatencyMS", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 23, name: "Corrections", kind: "message", T: NoteAIStepChange, repeated: true },
    { no: 24, name: "RemovedLineIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 25, name: "Transcript", kind: "enum", T: proto3.getEnumType(NoteAITranscript) },
    { no: 26, name: "ToolsVersion", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.NoteAIStepChange
 */
export const NoteAIStepChange = proto3.makeMessageType(
  "com.diagnocat.model.NoteAIStepChange",
  () => [
    { no: 1, name: "BlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Teeth", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "TeethGroups", kind: "enum", T: proto3.getEnumType(NoteTeethGroup), repeated: true },
    { no: 6, name: "EvidenceChunkIndexes", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 7, name: "EvidenceQuote", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "LineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "OldString", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "NewString", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "AIBasis", kind: "enum", T: proto3.getEnumType(NoteAIBasis) },
    { no: 13, name: "AISaid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "AIRationale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "None", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 16, name: "Marks", kind: "message", T: NoteToothMark, repeated: true },
    { no: 17, name: "EvidenceSource", kind: "enum", T: proto3.getEnumType(NoteEvidenceSource), opt: true },
    { no: 18, name: "Numbers", kind: "message", T: NoteNumberValue, repeated: true },
    { no: 19, name: "TableRows", kind: "message", T: NoteTableRowValue, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.NoteAIStepDrop
 */
export const NoteAIStepDrop = proto3.makeMessageType(
  "com.diagnocat.model.NoteAIStepDrop",
  () => [
    { no: 1, name: "Reason", kind: "enum", T: proto3.getEnumType(NoteAIDropReason) },
    { no: 2, name: "BlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "LineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "SectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.DocumentEditFeedback
 */
export const DocumentEditFeedback = proto3.makeMessageType(
  "com.diagnocat.model.DocumentEditFeedback",
  () => [
    { no: 1, name: "IssueType", kind: "enum", T: proto3.getEnumType(DocumentEditIssueType), opt: true },
    { no: 2, name: "IssueTypes", kind: "enum", T: proto3.getEnumType(DocumentEditIssueType), repeated: true },
    { no: 3, name: "OtherText", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "PreviousContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "NewContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ByUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "CreatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message com.diagnocat.model.LiteratureReference
 */
export const LiteratureReference = proto3.makeMessageType(
  "com.diagnocat.model.LiteratureReference",
  () => [
    { no: 1, name: "Index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Authors", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Year", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "Journal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Abstract", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "PMID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "DOI", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.PersonalInfo
 */
export const PersonalInfo = proto3.makeMessageType(
  "com.diagnocat.model.PersonalInfo",
  () => [
    { no: 1, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FullName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "DateOfBirth", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "PhoneNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Archival records who archived an encounter. Exactly one of ByUserID /
 * ByAPIKeyID is set, depending on how the caller authenticated.
 *
 * @generated from message com.diagnocat.model.Archival
 */
export const Archival = proto3.makeMessageType(
  "com.diagnocat.model.Archival",
  () => [
    { no: 1, name: "ByUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ByAPIKeyID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "At", kind: "message", T: Timestamp },
  ],
);

/**
 * Deletion records who deleted an encounter. Exactly one of ByUserID /
 * ByAPIKeyID is set, depending on how the caller authenticated.
 *
 * @generated from message com.diagnocat.model.Deletion
 */
export const Deletion = proto3.makeMessageType(
  "com.diagnocat.model.Deletion",
  () => [
    { no: 1, name: "ByUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ByAPIKeyID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "At", kind: "message", T: Timestamp },
  ],
);

/**
 * One "Complete with AI" request on a block note (EncounterService.
 * CompleteNote) and how its job went. Its rounds are NoteAIStep records of
 * kind Complete.
 *
 * @generated from message com.diagnocat.model.NoteCompletion
 */
export const NoteCompletion = proto3.makeMessageType(
  "com.diagnocat.model.NoteCompletion",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Status", kind: "enum", T: proto3.getEnumType(NoteCompletionStatus) },
    { no: 3, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "RequestedByUserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "RequestedAt", kind: "message", T: Timestamp },
    { no: 6, name: "FinishedAt", kind: "message", T: Timestamp, opt: true },
    { no: 7, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "SaidCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "AssumedCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "SuggestedCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "UnresolvedLineCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

